import classNames from 'classnames';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NSBadge, NSDropdown } from 'bricks';
import { IOptionAnyValue } from 'bricks/types';
import RenderIf from 'components/RenderIf/RenderIf';
import NSRadioCard from 'components/NSRadioCard/NSRadioCard';
import SlideOutReturnCard from 'views/DealDashboard/BOE/components/SlideoutForm/SlideOutReturnCard';

export interface IStartFromBoeSectionProps {
    isSelected: boolean;
    onSelect: () => void;
    scenarioDropdownOptions: IOptionAnyValue[];
    selectedScenario?: IOptionAnyValue;
    onSelectScenario: (option: IOptionAnyValue) => void;
    returnOnCost: number | null;
    returnOnEquity: number | null;
    profitReturn: number | null;
    targetReturnOnCost: number | null;
    targetReturnOnEquity: number | null;
    targetProfitReturn: number | null;
    onOpenSlideout: () => void;
}

const StartFromBoeSection = ({
    isSelected,
    onSelect,
    scenarioDropdownOptions,
    selectedScenario,
    onSelectScenario,
    returnOnCost,
    returnOnEquity,
    profitReturn,
    targetReturnOnCost,
    targetReturnOnEquity,
    targetProfitReturn,
    onOpenSlideout,
}: IStartFromBoeSectionProps) => (
    <NSRadioCard
        cardClassName={classNames('p-2 mb-2 NSCard--level-4', {
            'border border-primary': isSelected,
            'border border-secondary': !isSelected,
        })}
        onClick={onSelect}
    >
        <div className="d-flex justify-content-between">
            <NSBadge color="primary-lighten">Recommended</NSBadge>

            <RenderIf isTrue={isSelected}>
                <FontAwesomeIcon icon={faDotCircle} className="text-primary NSRadioCard__radio-btn--selected" />
            </RenderIf>
            <RenderIf isTrue={!isSelected}>
                <FontAwesomeIcon icon={faCircle} />
            </RenderIf>
        </div>
        <div className="text-white mb-1 mt-1">Start your pro forma from an existing Back-Of-Envelope scenario</div>

        <NSDropdown
            isFullWidth
            options={scenarioDropdownOptions}
            selectedOption={selectedScenario}
            handleSelectOption={onSelectScenario}
            placeholder="Select scenario"
            disableOnSingleOption={false}
        />

        <RenderIf isTrue={Boolean(selectedScenario)}>
            <hr className="my-1" />

            <div className="d-flex justify-content-between">
                <div className="d-flex flex-grow-1 mr-1">
                    <SlideOutReturnCard
                        title="Return on cost:"
                        returnValue={returnOnCost}
                        targetValue={targetReturnOnCost}
                        formatter="formatPercentage"
                    />
                </div>
                <div className="d-flex flex-grow-1 mr-1">
                    <SlideOutReturnCard
                        title="Return on equity:"
                        returnValue={returnOnEquity}
                        targetValue={targetReturnOnEquity}
                        formatter="formatPercentage"
                    />
                </div>
                <div className="d-flex flex-grow-1">
                    <SlideOutReturnCard
                        title="Profit return:"
                        returnValue={profitReturn}
                        targetValue={targetProfitReturn}
                        formatter="formatUSDCurrency"
                    />
                </div>
            </div>

            <div className="d-flex text-primary cursor--pointer mt-1" role="presentation" onClick={onOpenSlideout}>
                <small className="my-auto">View scenario in Back-Of-Envelope</small>
            </div>
        </RenderIf>
    </NSRadioCard>
);

export default StartFromBoeSection;
